import { render, staticRenderFns } from "./ConsentCheckBox.vue?vue&type=template&id=57df4fec"
import script from "./ConsentCheckBox.vue?vue&type=script&lang=js"
export * from "./ConsentCheckBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports